(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lc-clips"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lc-clips')) {
    class LcClips extends HTMLElement {
      connectedCallback() {
        this.onClick = this.onClick.bind(this);
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      onClick(event) {
        const toggle = event.target.closest('.lc-clips__toggle');
        if (!toggle) return;

        const video = toggle.parentElement.querySelector('video');
        if (!video) return;

        if (video.paused) {
          this.pauseAll(video);
          const started = video.play();
          if (started && typeof started.catch === 'function') started.catch(() => this.setState(toggle, false));
          this.setState(toggle, true);
        } else {
          video.pause();
          this.setState(toggle, false);
        }
      }

      pauseAll(except) {
        this.querySelectorAll('video').forEach((video) => {
          if (video === except || video.paused) return;
          video.pause();
          const toggle = video.parentElement.querySelector('.lc-clips__toggle');
          if (toggle) this.setState(toggle, false);
        });
      }

      setState(toggle, playing) {
        toggle.setAttribute('aria-pressed', playing ? 'true' : 'false');
      }
    }

    customElements.define('lc-clips', LcClips);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lc-edition"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lc-countdown')) {
    class LcCountdown extends HTMLElement {
      connectedCallback() {
        this.end = Number(this.dataset.end) * 1000;
        if (!Number.isFinite(this.end) || this.end <= 0) return;

        this.units = {
          days: this.querySelector('[data-unit="days"]'),
          hours: this.querySelector('[data-unit="hours"]'),
          minutes: this.querySelector('[data-unit="minutes"]'),
          seconds: this.querySelector('[data-unit="seconds"]'),
        };

        this.tick = this.tick.bind(this);
        this.tick();
        this.timer = window.setInterval(this.tick, 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
      }

      tick() {
        const left = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
        const pad = (value) => String(value).padStart(2, '0');

        if (this.units.days) this.units.days.textContent = String(Math.floor(left / 86400));
        if (this.units.hours) this.units.hours.textContent = pad(Math.floor((left % 86400) / 3600));
        if (this.units.minutes) this.units.minutes.textContent = pad(Math.floor((left % 3600) / 60));
        if (this.units.seconds) this.units.seconds.textContent = pad(left % 60);

        if (left > 0) return;

        window.clearInterval(this.timer);
        this.classList.add('is-ended');

        const inEditor = window.Shopify && window.Shopify.designMode;
        if (this.dataset.whenEnded === 'hide' && !inEditor) {
          const section = this.closest('.shopify-section');
          if (section) section.hidden = true;
        }
      }
    }

    customElements.define('lc-countdown', LcCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lc-pieces"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lc-piece')) {
    class LcPiece extends HTMLElement {
      connectedCallback() {
        this.onClick = this.onClick.bind(this);
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      onClick(event) {
        const config = event.target.closest('button.lc-pieces__config');
        if (config) {
          this.show(config);
          return;
        }

        /* "Me interesa esta": marca la pieza en el formulario de la lista */
        const interest = event.target.closest('[data-lc-piece-index]');
        if (!interest) return;
        const choices = document.querySelectorAll('.lc-waitlist__choice input');
        const choice = choices[Number(interest.dataset.lcPieceIndex) - 1];
        if (choice) choice.checked = true;
      }

      show(config) {
        const shots = this.querySelectorAll('.lc-pieces__shot');
        const hasMain = this.querySelector('.lc-pieces__shot[data-shot="0"]') !== null;
        const wasPressed = config.getAttribute('aria-pressed') === 'true';
        /* Tocar de nuevo la forma activa vuelve a la foto principal, si la hay */
        const target = wasPressed && hasMain ? '0' : config.dataset.shot;

        shots.forEach((shot) => shot.classList.toggle('is-active', shot.dataset.shot === target));
        this.querySelectorAll('button.lc-pieces__config').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.shot === target));
        });
      }
    }

    customElements.define('lc-piece', LcPiece);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
